import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsDownRightChevron: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.364 16L0 9.636h9.636V0L16 6.364V16z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsDownRightChevron
